import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import Slide from "../slide.js";
import AI_Example from "../img/AI_Example.png";
import Crow_img_2 from "../img/Crow/1.png";
import AI_1 from "../img/AI_1.png";
import AI_2_1 from "../img/AI_2_1.png";
import AI_2_2 from "../img/AI_2_2.png";
import AI_3 from "../img/AI_3.png";
import Video from "../img/video_test.mp4";
const Content_p = styled.p`
font-family: "Content";        

    margin : 20px 0 ; 
    font-size : 20px; 
    line-height : 40px;
    color : #212121;
`
function Studies_list(){
    return(
        <Wrapper_div>
            <Title_span>AI Research</Title_span>
            <Content_p>               Prediction model or epidemiologic study using Machine learning
                We use machine learning algorithm to make better prediction model or decision tool. eXplainable AI model to predict to have active surveillance for prostate cancer using SEER Prostate with Watchful Waiting DB (n=316,724) is one example.
</Content_p>
<AI_1_img src={AI_1}/>

            <UL>
                    <LI>
                    <Point_span/>Deep learning research using medical imaging
                    </LI>
                    <LI> 
                    We recently generated labeled medical image data (N=991,827) from Kidney CT, prostate MRI or bone scan for AI research. Now we perform various deep learning research for renal cell carcinoma or prostate cancer.
                    </LI>
            </UL>
               

                    <AI_IMG_div>
                    <AI_2_left src={AI_2_1}/><AI_2_right src={AI_2_2}/>
                    </AI_IMG_div>
                    <UL>   
                    <LI>
                    <Point_span/>Deep learning in digital pathology
                    </LI>
                    <LI>
                    We also labeled 14,366 prostate biopsy cores for cancer. We perform various deep learning projects in collaboration with Department of Pathology or other institutions. 
                    </LI>
                    </UL>
            <UL> 
                    <LI>
                    
                    <Point_span/>Deep learning project using surgical video
                    </LI>
                    <LI>
                    We perform various deep learning projects using surgical video. More than 3,000 surgical videos have been achieved and >1,000 surgical videos are prospectively collected per year. Recently, we focus on deep learning video analysis for robotic surgery in collaboration with Department of Artificial Intelligence, Kyungpook National University.
                    </LI>
                    </UL>        
                    <AI_3_img src={AI_3}/>
                    <Vidio_div>
                        <video height="300" width="700" src={Video} controls preload>
                            if
                        </video></Vidio_div>
                
            
        </Wrapper_div>
    )
}

const Vidio_div = styled.div`
    width : 700px; 
    height : 300px;
    margin : 50px auto ;
    display : block;
`
const AI_IMG_div = styled.div`
    width : 400px;
    margin: 0 auto;
`
const AI_2_left = styled.img`
    width : 200px;
    height : 200px;
`
const AI_2_right = styled.img`
    width : 200px;
    height : 200px;
`
const AI_3_img = styled.img`
    width : 700px;
    height : 200px;
    margin : 20px auto ;
    display : block; 
`
const AI_1_img = styled.img`
    display : block; 
    width : 700px;
    height : 370px;
    margin : 20px auto ;
`
function Multicenter_studies(){
    return (
        <Wrapper>
            <Slide imgURL={AI_Example} inputText="AI Research"/>
            <Studies_list/>
            <Crow_img2 src={Crow_img_2}/>
        </Wrapper>
    )
}  

const Wrapper = styled.div`
font-family: "En";        
position : relative; 
top : 90px;
width : 1200px; 
margin : 0 auto; 
font-size : 20px;
`
const Title_span = styled.span`
font-family: "Title";        
    display : inline-block;
    font-size : 35px; 
    font-weight : bold;
    margin-top :70px ;
`
const Wrapper_div = styled.div`
    margin : 0 10%;
    margin-bottom : 70px;
`
const UL = styled.ul`
margin : 40px 0;

`
const LI = styled.li`
margin : 0;
padding : 10px 40px;
font-size : 20px;
line-height : 30px;
color : #212121;
&:nth-child(2n){
    background:#E4F3FF;
    font-family: "Table_content";        

}
&:nth-child(2n-1){
    background:#F9F9F9;
    font-weight : bold;
    font-family: "Table_title";        
}
`
const Point_span = styled.span`        
    background :#32A4FF;
    width : 5px; 
    height : 5px; 
    line-height : 25px;
    display : inline-block; 
    border-radius : 100%;
    vertical-align : middle;
    margin : 0 10px;
`
const Crow_img2 = styled.img`
width : 150px; 
height : 149px;
position : absolute;
bottom:-80px;
right : 100px;
`
export default Multicenter_studies;